import { get } from 'lib/API';

export const getReportsData =async ([token, vendorName, reportId, viewCode, vendorId, brandId]: any): Promise<any> => {
  return await get(`v1/reports/powerBiReportsData`, token, {vendorName, reportId, viewCode, vendorId, brandId})
}

export const getReports =async ([token]: any): Promise<any> => {
  return await get(`v1/reports/powerBiReports`, token)
}